<template>
    <div v-if="model">
        <v-dialog v-model="model" max-width="500">
            <form>
                <v-card>
                    <v-container>
                        <validation :errors="errors" />
                        <v-card-title>
                            <span class="headline">Change password</span>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" class="py-1">
                                    <v-text-field type="password" v-model="oldPassword" label="Current password" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="py-1">
                                    <v-text-field type="password" v-model="newPassword" label="New password" />
                                </v-col>
                                <v-col cols="6" class="py-1">
                                    <v-text-field type="password" v-model="repeatPassword" label="Repeat password" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="cancel()" text :disabled="loading">Cancel</v-btn>
                            <v-btn color="primary" @click="save()" depressed :disabled="loading" type="submit">Change password</v-btn>
                        </v-card-actions>
                    </v-container>
                    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                </v-card>
            </form>
        </v-dialog>
    </div>
</template>

<script>
import { form } from '@/services/api';
import store from "@/services/store";
import Validation from "@/components/common/Validation";

export default {
    props: ["model"],
    data: () => ({
        loading: false,
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
        errors: []
    }),
    store,
    methods: {
        async save() {
            if (this.newPassword && this.newPassword !== this.repeatPassword) {
                this.errors.length = 0;
                this.errors.push("Passwords do not match.");

                return;
            }

            const req = {
                "oldPassword": this.oldPassword,
                "newPassword": this.newPassword
            };

            this.loading = true;
            this.errors.length = 0;

            const valid = await form("/changepassword", req, this.errors);

            this.loading = false;

            if (valid)
                this.$emit("close");
        },
        cancel() {
            this.oldPassword = this.newPassword = this.repeatPassword = "";
            this.errors = [];

            this.$emit('cancel')
        }
    },
    components: { Validation }
};
</script>